'use client'
import styles from './FooterBlock.Newsletter.module.scss'
import { SVGNewsletterImage } from '@/src/components/blocks/NavigationBlock/FooterBlock/FooterBlock.SVG'
import Form from '@/src/components/common/Form'
import { PropsWithChildren, useState } from 'react'
import { classNames } from '@/src/helpers/component'
import { Block_Footer } from '@/src/generated/graphql'
import WysiwygContent from '@/src/components/common/WysiwygContent'
import CTAButton from '@/src/components/common/CTAButton'

function Modal({ children, onClose }: PropsWithChildren<{ onClose: () => void }>) {
  return (
    <div
      className={classNames(styles.modal, 'modal-shown')}
      onClick={e => {
        if (!(e.target as HTMLElement).closest(`.${styles.modalContent}`)) onClose()
      }}>
      <div className={styles.modalContent}>{children}</div>
    </div>
  )
}

export default function Newsletter(_: Block_Footer) {
  const [isComplete, setComplete] = useState(false)
  const [modalShown, setModalShown] = useState(false)

  const toggleModal = (shown: boolean) => {
    setModalShown(shown)
  }

  return (
    <>
      <Form
        className={styles.container}
        formName={'newsletter_subscription'}
        afterChanged={({ isComplete }) => {
          setComplete(isComplete)
        }}
        afterSubmitted={({ success }) => {
          if (success) toggleModal(true)
          else {
            const message = 'An unexpected error occurred'
            alert(message)
            throw new Error(message)
          }
        }}>
        <SVGNewsletterImage className={styles.bgimage} />
        <div className={styles.contentContainer}>
          <div className={styles.copyContainer}>
            <div className={styles.header}>Sign up to our newsletter</div>
            <div className={styles.copy}>
              Keep up to date with our latest news, activities and home care updates.
            </div>
          </div>
          <div className={styles.signupForm}>
            <input
              required
              type={'email'}
              name={'email'}
              placeholder={'Email address'}
              autoComplete={'off'}
            />
            <button className={classNames(styles.btnSignup, isComplete ? '' : styles.disabled)}>
              Sign up
            </button>
          </div>
        </div>
      </Form>
      {modalShown && (
        <Modal
          onClose={() => {
            toggleModal(false)
          }}>
          <WysiwygContent content={_.newsletter_confirmation_content ?? ''} />
          <CTAButton
            text={'CLOSE'}
            theme_color={'inverse'}
            className={styles.modalCtaClose}
            onClick={e => {
              e.preventDefault()
              toggleModal(false)
            }}
          />
        </Modal>
      )}
    </>
  )
}
